import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {fundraiserImageApi} from '../api';
import {FundraiserImagesModel} from '../model';
import {useNotifications} from '../../../shared';

export const useAppealsImages = ({fundraiserId}: {fundraiserId: string}) => {
  const {createNotification} = useNotifications();

  const queryClient = useQueryClient();
  const getAppealsImages = useQuery<FundraiserImagesModel, Error>({
    queryKey: ['appealsImages', fundraiserId],
    queryFn: () => fundraiserImageApi.getImages(fundraiserId),
  });

  const deleteMainImageMutation = useMutation({
    mutationFn: (fileName: string) => fundraiserImageApi.deleteMainImage(fundraiserId, fileName),
    onSuccess: () => {
      createNotification({
        name: 'delete-main-image-success',
        title: 'Изображение удалено',
        theme: 'success',
      });
      queryClient.invalidateQueries({queryKey: ['appealsImages', fundraiserId]});
    },
  });

  const deleteFeedImageMutation = useMutation({
    mutationFn: (fileName: string) => fundraiserImageApi.deleteFeedImage(fundraiserId, fileName),
    onSuccess: () => {
      createNotification({
        name: 'delete-feed-image-success',
        title: 'Изображение удалено',
        theme: 'success',
      });
      queryClient.invalidateQueries({queryKey: ['appealsImages', fundraiserId]});
    },
  });

  const deleteAvatarImageMutation = useMutation({
    mutationFn: (fileName: string) => fundraiserImageApi.deleteAvatarImage(fundraiserId, fileName),
    onSuccess: () => {
      createNotification({
        name: 'delete-avatar-image-success',
        title: 'Изображение удалено',
        theme: 'success',
      });
      queryClient.invalidateQueries({queryKey: ['appealsImages', fundraiserId]});
    },
  });

  const updateMainImagesOrderMutation = useMutation({
    mutationFn: (images: string[]) => fundraiserImageApi.updateMainImagesOrder(fundraiserId, images),
    onSuccess: () => {
      createNotification({
        name: 'update-main-images-order-success',
        title: 'Порядок изображений обновлен',
        theme: 'success',
      });
      queryClient.invalidateQueries({queryKey: ['appealsImages', fundraiserId]});
    },
    onError: () => {
      createNotification({
        name: 'update-main-images-order-error',
        title: 'Ошибка при обновлении порядка изображений',
        theme: 'danger',
      });
    },
  });

  const updateFeedImagesOrderMutation = useMutation({
    mutationFn: (images: string[]) => fundraiserImageApi.updateFeedImagesOrder(fundraiserId, images),
    onSuccess: () => {
      createNotification({
        name: 'update-feed-images-order-success',
        title: 'Порядок изображений обновлен',
        theme: 'success',
      });
      queryClient.invalidateQueries({queryKey: ['appealsImages', fundraiserId]});
    },
    onError: () => {
      createNotification({
        name: 'update-feed-images-order-error',
        title: 'Ошибка при обновлении порядка изображений',
        theme: 'danger',
      });
    },
  });

  return {
    getAppealsImages,
    deleteMainImageMutation,
    deleteFeedImageMutation,
    deleteAvatarImageMutation,
    updateMainImagesOrderMutation,
    updateFeedImagesOrderMutation,
  };
};
